import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { generateReactKey } from 'src/common/helpers/common.helpers';

import { getCorrectFormatEmployeeInfoField } from 'src/components/employee/employee-details.helpers';

import { IEmergencyContact } from '../../../../../auth/sub-pages/questionnaire/questionnaire.interfaces';

import {
  InfoBlock,
  InfoBlockContainer,
  InfoElement,
  InfoWrapper,
  InfoWrapperTitle,
} from '../../open-questionnaires-details.styles';

const EmergencyContactQuestionnairesDetails = ({
  emergencyContact,
}: {
  emergencyContact: IEmergencyContact;
}) => {
  const { t } = useTranslation('employee');

  const { maritalStatus, childAllowance, name, phoneNumber, relationship } = emergencyContact;

  const firstColumn = {
    name,
    phoneNumber,
  };

  const secondColumn = {
    relationship,
    childAllowance,
  };

  const thirdColumn = {
    maritalStatus,
  };

  const data = [firstColumn, secondColumn, thirdColumn];

  return (
    <InfoWrapper>
      <InfoWrapperTitle>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:questionnaire.labels.emergencyContact')}
        </Typography>
      </InfoWrapperTitle>

      <InfoBlock>
        {data.map(el => {
          return (
            <InfoBlockContainer key={generateReactKey()}>
              {Object.entries(el).map(([key, value]) => {
                return (
                  <InfoElement key={generateReactKey()}>
                    <Typography weight="bold">{`${t(
                      `employee:questionnaire.emergencyContact.labels.${key}`
                    )}`}</Typography>
                    <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                      {getCorrectFormatEmployeeInfoField({ t, key, value }) || '-'}
                    </Typography>
                  </InfoElement>
                );
              })}
            </InfoBlockContainer>
          );
        })}
      </InfoBlock>
    </InfoWrapper>
  );
};

export default EmergencyContactQuestionnairesDetails;
